export default __webpack_public_path__ + "static/media/background3.37c7dc5b.png";